export class OutcomeClassService {
  static getOutcomeClasses = () => {
    return Promise.resolve().then(() => {
      return [
        { name: "New", id: "new" },
        { name: "Private", id: "private" },
        { name: "Variant", id: "variant" },
        { name: "Version", id: "version" },
      ];
    });
  };
}
